import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomePage from "./pages/home";
import TeamPage from "./pages/team";
import ServicesPage from "./pages/services";
import ContactsPage from "./pages/contacts";

function App() {
  return (
      <>
          <BrowserRouter>
              <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="*" element={<HomePage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/team" element={<TeamPage />} />
                  <Route path="/contacts" element={<ContactsPage />} />
              </Routes>
          </BrowserRouter>
    <div>
    </div>
          </>
  );
}

export default App;
